module.exports = __webpack_public_path__ + "img/symbol_5.e0a9b8b8.png";